/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PlannerRouteImport } from './routes/_planner'
import { Route as ContactUsRouteImport } from './routes/contact-us'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as WarrantyRouteImport } from './routes/warranty'
import { Route as PlannerCartRouteImport } from './routes/_planner.cart'
import { Route as PlannerPlannerColourRouteImport } from './routes/_planner.planner.colour'
import { Route as PlannerPlannerLockRouteImport } from './routes/_planner.planner.lock'
import { Route as PlannerPlannerMeasureRouteImport } from './routes/_planner.planner.measure'
import { Route as PlannerPlannerReviewRouteImport } from './routes/_planner.planner.review'
import { Route as PlannerPlannerTypeRouteImport } from './routes/_planner.planner.type'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerRoute = PlannerRouteImport.update({
  id: '/_planner',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactUsRoute = ContactUsRouteImport.update({
  id: '/contact-us',
  path: '/contact-us',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const WarrantyRoute = WarrantyRouteImport.update({
  id: '/warranty',
  path: '/warranty',
  getParentRoute: () => rootRouteImport,
} as any)
const PlannerCartRoute = PlannerCartRouteImport.update({
  id: '/cart',
  path: '/cart',
  getParentRoute: () => PlannerRoute,
} as any)
const PlannerPlannerColourRoute = PlannerPlannerColourRouteImport.update({
  id: '/planner/colour',
  path: '/planner/colour',
  getParentRoute: () => PlannerRoute,
} as any)
const PlannerPlannerLockRoute = PlannerPlannerLockRouteImport.update({
  id: '/planner/lock',
  path: '/planner/lock',
  getParentRoute: () => PlannerRoute,
} as any)
const PlannerPlannerMeasureRoute = PlannerPlannerMeasureRouteImport.update({
  id: '/planner/measure',
  path: '/planner/measure',
  getParentRoute: () => PlannerRoute,
} as any)
const PlannerPlannerReviewRoute = PlannerPlannerReviewRouteImport.update({
  id: '/planner/review',
  path: '/planner/review',
  getParentRoute: () => PlannerRoute,
} as any)
const PlannerPlannerTypeRoute = PlannerPlannerTypeRouteImport.update({
  id: '/planner/type',
  path: '/planner/type',
  getParentRoute: () => PlannerRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/warranty': typeof WarrantyRoute
  '/cart': typeof PlannerCartRoute
  '/planner/colour': typeof PlannerPlannerColourRoute
  '/planner/lock': typeof PlannerPlannerLockRoute
  '/planner/measure': typeof PlannerPlannerMeasureRoute
  '/planner/review': typeof PlannerPlannerReviewRoute
  '/planner/type': typeof PlannerPlannerTypeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/contact-us': typeof ContactUsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/warranty': typeof WarrantyRoute
  '/cart': typeof PlannerCartRoute
  '/planner/colour': typeof PlannerPlannerColourRoute
  '/planner/lock': typeof PlannerPlannerLockRoute
  '/planner/measure': typeof PlannerPlannerMeasureRoute
  '/planner/review': typeof PlannerPlannerReviewRoute
  '/planner/type': typeof PlannerPlannerTypeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_planner': typeof PlannerRouteWithChildren
  '/contact-us': typeof ContactUsRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/warranty': typeof WarrantyRoute
  '/_planner/cart': typeof PlannerCartRoute
  '/_planner/planner/colour': typeof PlannerPlannerColourRoute
  '/_planner/planner/lock': typeof PlannerPlannerLockRoute
  '/_planner/planner/measure': typeof PlannerPlannerMeasureRoute
  '/_planner/planner/review': typeof PlannerPlannerReviewRoute
  '/_planner/planner/type': typeof PlannerPlannerTypeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/contact-us'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/warranty'
    | '/cart'
    | '/planner/colour'
    | '/planner/lock'
    | '/planner/measure'
    | '/planner/review'
    | '/planner/type'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/contact-us'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/warranty'
    | '/cart'
    | '/planner/colour'
    | '/planner/lock'
    | '/planner/measure'
    | '/planner/review'
    | '/planner/type'
  id:
    | '__root__'
    | '/'
    | '/_planner'
    | '/contact-us'
    | '/privacy-policy'
    | '/terms-and-conditions'
    | '/warranty'
    | '/_planner/cart'
    | '/_planner/planner/colour'
    | '/_planner/planner/lock'
    | '/_planner/planner/measure'
    | '/_planner/planner/review'
    | '/_planner/planner/type'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  PlannerRoute: typeof PlannerRouteWithChildren
  ContactUsRoute: typeof ContactUsRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  WarrantyRoute: typeof WarrantyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_planner': {
      id: '/_planner'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof PlannerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-us': {
      id: '/contact-us'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof ContactUsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/warranty': {
      id: '/warranty'
      path: '/warranty'
      fullPath: '/warranty'
      preLoaderRoute: typeof WarrantyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_planner/cart': {
      id: '/_planner/cart'
      path: '/cart'
      fullPath: '/cart'
      preLoaderRoute: typeof PlannerCartRouteImport
      parentRoute: typeof PlannerRoute
    }
    '/_planner/planner/colour': {
      id: '/_planner/planner/colour'
      path: '/planner/colour'
      fullPath: '/planner/colour'
      preLoaderRoute: typeof PlannerPlannerColourRouteImport
      parentRoute: typeof PlannerRoute
    }
    '/_planner/planner/lock': {
      id: '/_planner/planner/lock'
      path: '/planner/lock'
      fullPath: '/planner/lock'
      preLoaderRoute: typeof PlannerPlannerLockRouteImport
      parentRoute: typeof PlannerRoute
    }
    '/_planner/planner/measure': {
      id: '/_planner/planner/measure'
      path: '/planner/measure'
      fullPath: '/planner/measure'
      preLoaderRoute: typeof PlannerPlannerMeasureRouteImport
      parentRoute: typeof PlannerRoute
    }
    '/_planner/planner/review': {
      id: '/_planner/planner/review'
      path: '/planner/review'
      fullPath: '/planner/review'
      preLoaderRoute: typeof PlannerPlannerReviewRouteImport
      parentRoute: typeof PlannerRoute
    }
    '/_planner/planner/type': {
      id: '/_planner/planner/type'
      path: '/planner/type'
      fullPath: '/planner/type'
      preLoaderRoute: typeof PlannerPlannerTypeRouteImport
      parentRoute: typeof PlannerRoute
    }
  }
}

interface PlannerRouteChildren {
  PlannerCartRoute: typeof PlannerCartRoute
  PlannerPlannerColourRoute: typeof PlannerPlannerColourRoute
  PlannerPlannerLockRoute: typeof PlannerPlannerLockRoute
  PlannerPlannerMeasureRoute: typeof PlannerPlannerMeasureRoute
  PlannerPlannerReviewRoute: typeof PlannerPlannerReviewRoute
  PlannerPlannerTypeRoute: typeof PlannerPlannerTypeRoute
}

const PlannerRouteChildren: PlannerRouteChildren = {
  PlannerCartRoute: PlannerCartRoute,
  PlannerPlannerColourRoute: PlannerPlannerColourRoute,
  PlannerPlannerLockRoute: PlannerPlannerLockRoute,
  PlannerPlannerMeasureRoute: PlannerPlannerMeasureRoute,
  PlannerPlannerReviewRoute: PlannerPlannerReviewRoute,
  PlannerPlannerTypeRoute: PlannerPlannerTypeRoute,
}

const PlannerRouteWithChildren =
  PlannerRoute._addFileChildren(PlannerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  PlannerRoute: PlannerRouteWithChildren,
  ContactUsRoute: ContactUsRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  WarrantyRoute: WarrantyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
